import { render, staticRenderFns } from "./events-company-filters.vue?vue&type=template&id=da208468&scoped=true&"
import script from "./events-company-filters.vue?vue&type=script&lang=js&"
export * from "./events-company-filters.vue?vue&type=script&lang=js&"
import style0 from "./events-company-filters.vue?vue&type=style&index=0&id=da208468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da208468",
  null
  
)

export default component.exports